'use client';
import React from 'react';
import { truncate } from '@benzinga/utils';
import { useTranslation } from 'react-i18next';
import { BaseQuoteProfile } from '../../utils/quote/types';
import styles from './AboutQuote.module.scss';

interface AboutQuote {
  profile: BaseQuoteProfile;
}

const AboutQuote = ({ profile }: AboutQuote) => {
  const { t } = useTranslation('quote');
  const [shortenedDescription, setShortenedDescription] = React.useState(true);

  const handleToggleShowMore = () => setShortenedDescription(!shortenedDescription);

  const companyDescriptionToUse = React.useMemo(() => {
    return profile?.tickerDetails?.company?.longDescription || '';
  }, [profile?.tickerDetails?.company?.longDescription]);

  return (
    <div className={`${styles.aboutQuoteWrapper} w-full`}>
      <div className="card financials-right-spacer overflow-hidden">
        <h2
          className="card-title uppercase"
          title={`${t('Quote.About.about')} ${profile?.richQuoteData?.companyStandardName} `}
        >
          {t('Quote.About.about')}
        </h2>
        <div className="flex items-center justify-between mt-1.5">
          <div className="flex flex-col">
            <div className="title-gray">{t('Quote.About.sector')}</div>
            <div className="value-black font-bold">
              {profile?.richQuoteData?.sector?.length ? profile?.richQuoteData?.sector : t('Fields.n-a')}
            </div>
          </div>
        </div>
        <div className="flex items-center justify-between mt-1.5">
          <div className="flex flex-col">
            <div className="title-gray">{t('Quote.About.industry')}</div>
            <div className="value-black font-bold">{profile?.richQuoteData?.industry || t('Fields.n-a')}</div>
          </div>
        </div>

        {companyDescriptionToUse?.length > 0 && (
          <div className="title-gray mt-2 mb-8">
            {shortenedDescription ? `${truncate(companyDescriptionToUse, 250)}` : companyDescriptionToUse}
          </div>
        )}

        {companyDescriptionToUse?.length > 250 && (
          <div className="show-more-about font-bold" onClick={handleToggleShowMore}>
            {shortenedDescription ? t('Buttons.show-more') : t('Buttons.show-less')}
          </div>
        )}
      </div>

      {/* Team Card */}
      {/* {isAdvertiser && (
        <div className="team-card mt-4 border border-bzblue-400 rounded overflow-hidden">
          <div className="team-header flex items-center">
            <div className="team-header-title">{t('Quote.About.team')}</div>
            <div className="negative-tab-wrapper team-header-tabs">
              <div
                className={`negative-tab ${teamMode === 'executives' ? 'active' : ''}`}
                onClick={() => handleTeamModeChange('executives')}
              >
                <div className="simple-tab-text">{t('Quote.About.executives')}</div>
              </div>
              <div
                className={`negative-tab ${teamMode === 'board' ? 'active' : ''}`}
                onClick={() => handleTeamModeChange('board')}
              >
                <div className="simple-tab-text">{t('Quote.About.board')}</div>
              </div>
            </div>
          </div>
          {teamMode === 'executives' && (
            <div className="team-body">
              {advertiserProfile?.info?.[0]?.value?.slice(0, 5)?.map((member, index) => (
                <div className="team-member" key={index}>
                  <div className="team-member-image">
                    <Icon icon={faUser} />
                  </div>
                  <div className="flex flex-col gap-2 ml-4">
                    <div className="team-member-name">{member?.name}</div>
                    <div className="team-member-title">{member?.title}</div>
                  </div>
                </div>
              ))}
            </div>
          )}

          {teamMode === 'board' && (
            <div className="team-body">
              {advertiserProfile?.info?.[1]?.value?.slice(0, 5)?.map((member, index) => (
                <div className="team-member" key={index}>
                  <div className="team-member-image">
                    <Icon icon={faUser} />
                  </div>
                  <div className="flex flex-col gap-2 ml-4">
                    <div className="team-member-name">{member?.name}</div>
                    <div className="team-member-title">{member?.title}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
          <div className="flex items-center justify-between team-footer">
            <div className="font-bold">{t('Quote.About.other-members')}</div>
            <div className="font-bold">
              {teamMode === 'executives'
                ? advertiserProfile?.info?.[0]?.value?.length - 5
                : advertiserProfile?.info?.[1]?.value?.length - 5}
              +
            </div>
          </div>
        </div>
      )} */}

      {/* Contact Card */}
    </div>
  );
};

export default AboutQuote;
